const useGetConfigData = () => {
  return process.env;
}
export default useGetConfigData;